import { SupportedCurrencies } from '@monorepo/types';

export const CurrencyToSign: { [key: string]: string } = {
  [SupportedCurrencies.INR]: '₹',
  [SupportedCurrencies.USD]: '$',
  [SupportedCurrencies.EUR]: '€',
  [SupportedCurrencies.GBP]: '£',
};

export type PaymentPageResponse = {
  paymentPage: string;
};
